/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Feat_Fee_35_TitleInputs */

const en_upgrade_feat_fee_35_title = /** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest Fees: 3.5%`)
};

const es_upgrade_feat_fee_35_title = /** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifas más bajas: 3.5%`)
};

const fr_upgrade_feat_fee_35_title = /** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frais les plus bas : 3,5 %`)
};

const de_upgrade_feat_fee_35_title = /** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrigste Gebühren: 3.5%`)
};

const id_upgrade_feat_fee_35_title = /** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya Terendah: 3.5%`)
};

/** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */
const ja_upgrade_feat_fee_35_title = en_upgrade_feat_fee_35_title;

/** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */
const zh_upgrade_feat_fee_35_title = en_upgrade_feat_fee_35_title;

/** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */
const ar_upgrade_feat_fee_35_title = en_upgrade_feat_fee_35_title;

/** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */
const it_upgrade_feat_fee_35_title = en_upgrade_feat_fee_35_title;

/** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */
const ru_upgrade_feat_fee_35_title = en_upgrade_feat_fee_35_title;

/** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */
const pt_upgrade_feat_fee_35_title = en_upgrade_feat_fee_35_title;

/** @type {(inputs: Upgrade_Feat_Fee_35_TitleInputs) => LocalizedString} */
const ko_upgrade_feat_fee_35_title = en_upgrade_feat_fee_35_title;

/**
* | output |
* | --- |
* | "Lowest Fees: 3.5%" |
*
* @param {Upgrade_Feat_Fee_35_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_feat_fee_35_title = /** @type {((inputs?: Upgrade_Feat_Fee_35_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Feat_Fee_35_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_feat_fee_35_title(inputs)
	if (locale === "es") return es_upgrade_feat_fee_35_title(inputs)
	if (locale === "fr") return fr_upgrade_feat_fee_35_title(inputs)
	if (locale === "de") return de_upgrade_feat_fee_35_title(inputs)
	if (locale === "ja") return ja_upgrade_feat_fee_35_title(inputs)
	if (locale === "zh") return zh_upgrade_feat_fee_35_title(inputs)
	if (locale === "ar") return ar_upgrade_feat_fee_35_title(inputs)
	if (locale === "id") return id_upgrade_feat_fee_35_title(inputs)
	if (locale === "it") return it_upgrade_feat_fee_35_title(inputs)
	if (locale === "ru") return ru_upgrade_feat_fee_35_title(inputs)
	if (locale === "pt") return pt_upgrade_feat_fee_35_title(inputs)
	return ko_upgrade_feat_fee_35_title(inputs)
});